<template>
  <div class="">
    <PCNavbar />
    <MobileNavBar />

    <CarouselHome  />
    
    <!-- 荣誉证书轮播图 -->
    <!-- <TodoShow/> -->
    <!-- 公司介绍 -->
    <!-- <CompanyProfile/> -->
    <!-- 企业文化 -->
    <!-- <div class="page-item">
      <EnterpriseCulture/>
    </div> -->
    <!-- 业务领域 -->
    <!-- <BusinessScope/> -->
    <!-- 企业动态 -->
    <!-- <News/> -->
    <!-- <div class="bottom_circle">
      <h1>产业大脑将会是所有城市园区产业发展的标准配置</h1>
      <div class="circle_img">
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-xs-only"/>
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-sm-and-up"/>
      </div>
    </div> -->
    <!-- <CoreCompetence/>
    <CooperationCustomer/> -->
    <CallMe/>  
    <div class="messageBox hidden-xs-only">
      <!-- 动画图标 -->
      <div 
        class="Itemlogo animated-logo" 
        :class="{ 'logo-final': isLogoFinalPosition, 'logo-hover': isLogoHover }"
        @click="animateLogoToFinalPosition"
        @mouseenter="isLogoHover = true"
        @mouseleave="isLogoHover = false"
      >
        <div class="tipsBox" v-if="!hasLogoBeenAnimated">
          <img 
            :src="currentImage" 
            :class="{ 'visible': isVisible }"
          />
        </div>
        <div class="iconBox">
          <img style="width:100%" class="icon1" :src="logo" alt=""/>
        </div>
      </div> 
      <div v-if="hasLogoBeenAnimated">
        <div 
          v-for="(item, index) in messageList" 
          :key="index" 
          class="messageItem" 
          @click="handleItem(item)" 
          :class="item.isShow ? 'show' : ''"
        >
          <div class="iconBox">
            <img class="icon" :src="item.isShow ? item.showIcon:item.icon" alt=""/>
          </div>
          <div class="title" :class="item.isShow ? 'title1' : ''">{{item.title}}</div>
        </div>
      </div>
    </div> 
    <!-- <MobileCallme/> -->
    <div class="messageModle hidden-xs-only" @click.stop="showMessageModle" v-if="showModule">
      <div  class="content" @click.stop>
        <el-row  type="flex" align="middle">
          <el-col :span="18">
            <div class="title">{{moduleInfo.title}}</div>
            <div v-if="moduleInfo.desc != '微信公众号'">
              <div class="desc">{{moduleInfo.desc}}</div>
              <div class="email">{{moduleInfo.email}}</div>
            </div>
            <div v-else>
              <div class="codeBox">
                 <div style="font-size: 19px;color: #2c2c2c;">{{moduleInfo.desc}}：</div>
                  <img class="code" :src="code"/>
              </div>
            </div>
            <div class="ads">{{moduleInfo.ads}}</div>
          </el-col>
          <el-col :span="6">
            <el-image class="logo" :src="logo"></el-image>
          </el-col>
        </el-row>
      </div>
    </div>
  </div> 
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import TodoShow from '@/components/todo_show/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import CompanyProfile from '@/components/company_profile/index.vue'
import EnterpriseCulture from '@/components/enterprise_culture/index.vue'
import BusinessScope from '@/components/business_scope/index.vue'
import News from '@/components/news/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CallMe,
    MobileCallme,
    CompanyProfile,
    EnterpriseCulture,
    BusinessScope,
    News
  },
  data() {
    return {
      code: require('@/assets/img/home/code.jpg'),
      messageList:[
        {
          icon: require('@/assets/img/home/icon1.png'),
          showIcon: require('@/assets/img/home/show1.png'),
          title: '前台咨询电话',
          isShow: false,
          messageInfo: {
            title: '联系我们',
            desc: '前台咨询电话',
            email: '0851-87982219',
            ads: '贵州省贵阳市观山湖区大唐东源财富广场6栋10楼1002室（工作时间周一至周五9:00-18：00）'
          }
        },
        {
          icon: require('@/assets/img/home/icon4.png'),
          showIcon: require('@/assets/img/home/show4.png'),
          title: '商家服务热线',
          isShow: false,
          messageInfo: {
            title: '联系我们',
            desc: '商家服务热线',
            email: '0851-82202617',
            ads: '贵州省贵阳市观山湖区大唐东源财富广场6栋10楼1002室（工作时间周一至周五9:00-18：00）'
          }
        },
        {
          icon: require('@/assets/img/home/icon2.png'),
          showIcon: require('@/assets/img/home/show2.png'),
          title: '电子邮箱',
          isShow: false,
          messageInfo: {
            title: '联系我们',
            desc: '电子邮箱',
            email: '3173906443@qq.com',
            ads: '贵州省贵阳市观山湖区大唐东源财富广场6栋10楼1002室（工作时间周一至周五9:00-18：00）'
          }
        },
        {
          icon: require('@/assets/img/home/icon3.png'),
          showIcon: require('@/assets/img/home/show3.png'),
          title: '微信公众号',
          isShow: false,
          messageInfo: {
            title: '联系我们',
            desc: '微信公众号',
            email: '40025005014057.com   |  2131321321545.com',
            ads: '贵州省贵阳市观山湖区大唐东源财富广场6栋10楼1002室（工作时间周一至周五9:00-18：00）'
          }
        },
      ],
      logo: require('@/assets/img/home/icon5.png'),
      showModule: false,
      moduleInfo: {
        title: '',
        desc: '',
        email: '',
        ads: ''
      },
      // ========== 动画提示相关数据 ==========
      images: [
        require('@/assets/img/home/tips1.png'),
        require('@/assets/img/home/tips2.png'),
        require('@/assets/img/home/tips3.png'),
        require('@/assets/img/home/tips4.png')
      ],
      currentIndex: 0,
      isVisible: true,
      showTimer: null,
      hideTimer: null,
      // ========== 动画相关数据 ==========
      isLogoFinalPosition: false, // 是否已经到达最终位置
      isLogoHover: false, // 鼠标悬停状态
      hasLogoBeenAnimated: false, // 是否已经执行过动画
      // ========== 2. 分页逻辑核心变量（新增） ==========
      currentPage: 0, // 当前页面索引（封面=0，section1=1，section2=2，BusinessScope=3）
      TIME_LIMIT: 1000, // 防连续滚动时间限制（毫秒）
      lastScrollTime: 0, // 上次滚动时间戳
      lastPageTop: 0, // 最后一页顶部位置
      pages: [], // 所有分页元素集合（.page-item）
      lastPageIndex: 0, // 最后一页索引
      lastPage: null // 最后一页DOM元素
    }
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex]
    }
  },
  created() {
  },
  mounted() {
    // ========== 3. 分页逻辑初始化（新增） ==========
    this.initPagination()
    // 动画提示
    this.startSequence()
    this.addVisibilityListener()
  },
  beforeUnmount() {
    // ========== 4. 移除事件监听（防止内存泄漏，新增） ==========
    this.removePaginationEvents()
    //动画提示
    this.removeVisibilityListener()
    this.clearTimers()
  },
  methods: {
     // 开始序列
     startSequence() {
      this.clearTimers()
      this.showImage()
    },
    
    // 显示图片
    showImage() {
      this.isVisible = true
      console.log('显示图片:', this.currentIndex + 1)
      
      // 3秒后隐藏图片
      this.hideTimer = setTimeout(() => {
        this.hideImage()
      }, 3000)
    },
    
    // 隐藏图片
    hideImage() {
      this.isVisible = false
      // 8秒后切换到下一张并显示
      this.showTimer = setTimeout(() => {
        this.nextImage()
      }, 8000)
    },
    
    // 切换到下一张图片
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
      this.showImage()
    },
    
    // 添加页面可见性监听
    addVisibilityListener() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    
    // 移除页面可见性监听
    removeVisibilityListener() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
    
    // 处理页面可见性变化
    handleVisibilityChange() {
      if (document.hidden) {
        console.log('页面隐藏，清除定时器')
        this.clearTimers()
      } else {
        console.log('页面显示，重新开始序列')
        this.startSequence()
      }
    },
    
    // 清除所有定时器
    clearTimers() {
      if (this.showTimer) {
        clearTimeout(this.showTimer)
        this.showTimer = null
      }
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },

    // ========== 动画相关方法 ==========
    // 点击图标触发动画
    animateLogoToFinalPosition() {
      // if (this.hasLogoBeenAnimated) return;
      
      this.isLogoFinalPosition = !this.isLogoFinalPosition;
      this.hasLogoBeenAnimated = !this.hasLogoBeenAnimated;
      if (this.hasLogoBeenAnimated) {
        this.clearTimers()
      }else{
        this.startSequence()
      }
    },
    
    // 重置动画（可选功能）
    resetLogoAnimation() {
      this.isLogoFinalPosition = false;
      this.isLogoHover = false;
      this.hasLogoBeenAnimated = false;
    },

    //显示隐藏弹窗
    showMessageModle(){
      this.showModule = !this.showModule
      let { messageList } = this
      messageList.forEach(i => {
        i.isShow = false
      });
      this.messageList = messageList
    },
    //点解悬浮图标
    handleItem(e){
      let { messageList } = this
      messageList.forEach(i => {
        i.isShow = e.title == i.title ?  (i.isShow = !i.isShow ) : false
      });
      this.showModule = e.isShow
      this.messageList = messageList
      this.moduleInfo = e.messageInfo
    },
    // ========== 5. 原有方法：适配分页逻辑（修改） ==========
    scrollToScreen() {
      const targetPageIndex = 0 // 目标页：第一个section（对应模板中.page-item索引1）
      this.currentPage = targetPageIndex
      this.lastScrollTime = Date.now() // 更新滚动时间，避免与wheel事件冲突
      this.pages[targetPageIndex].scrollIntoView({ behavior: 'smooth' })
    },

    // ========== 6. 分页逻辑工具函数（新增） ==========
    // 计算元素在文档中的绝对顶部位置（不是视口内位置）
    getElementPosition(element) {
      return element.getBoundingClientRect().top + window.scrollY
    },

    // 判断是否在最后一页的顶部区域（允许10px误差）
    isLastPageAtTop() {
      return window.scrollY >= this.lastPageTop - 10 && window.scrollY <= this.lastPageTop + 10
    },

    // 更新最后一页的顶部位置（窗口 resize 时需重新计算）
    updateLastPagePosition() {
      this.lastPageTop = this.getElementPosition(this.lastPage)
    },

    // ========== 7. 分页逻辑：初始化（新增） ==========
    initPagination() {
      // 1. 获取所有分页元素（.page-item）
      this.pages = document.querySelectorAll('.page-item')
      // 2. 初始化最后一页信息
      this.lastPageIndex = this.pages.length - 1
      this.lastPage = this.pages[this.lastPageIndex]
      // 3. 初始化最后一页顶部位置
      this.updateLastPagePosition()
      // 4. 添加事件监听
      this.addPaginationEvents()
    },

    // ========== 8. 分页逻辑：添加事件监听（新增） ==========
    addPaginationEvents() {
      // 窗口 resize 时更新最后一页位置
      window.addEventListener('resize', this.updateLastPagePosition)
      // 鼠标滚轮事件（核心：控制页面切换）
      window.addEventListener('wheel', this.handleWheel, { passive: false })
      // 滚动事件（辅助：更新当前页面索引，防止手动滚动后索引错乱）
      window.addEventListener('scroll', this.handleScrollUpdateCurrentPage)
    },

    // ========== 9. 分页逻辑：移除事件监听（新增） ==========
    removePaginationEvents() {
      window.removeEventListener('resize', this.updateLastPagePosition)
      window.removeEventListener('wheel', this.handleWheel, { passive: false })
      window.removeEventListener('scroll', this.handleScrollUpdateCurrentPage)
    },

    // ========== 10. 分页逻辑：滚轮事件处理（核心，新增） ==========
    handleWheel(e) {
      const now = Date.now()

      // 情况1：当前在最后一页
      if (this.currentPage === this.lastPageIndex) {
        // 判断最后一页是否有可滚动内容（内容高度 > 视口高度）
        const lastPageHasScrollableContent = this.lastPage.offsetHeight > window.innerHeight

        // 向下滚动：允许正常浏览最后一页内容
        if (e.deltaY > 0) {
          // 不在最后一页顶部，或最后一页有滚动内容 → 允许正常滚动
          if (!this.isLastPageAtTop() || lastPageHasScrollableContent) {
            return // 不阻止默认行为
          }
        }
        // 向上滚动：回到上一页（需满足"不在时间限制内"+"在最后一页顶部"）
        else {
          if (this.isLastPageAtTop()) {
            // 防连续滚动：1秒内不重复触发
            if (now - this.lastScrollTime < this.TIME_LIMIT) {
              e.preventDefault()
              return
            }
            // 切换到上一页
            this.lastScrollTime = now
            this.currentPage = this.lastPageIndex - 1
            this.pages[this.currentPage].scrollIntoView({ behavior: 'smooth' })
            e.preventDefault()
          } else {
            return // 不在顶部 → 允许正常向上滚动
          }
        }
      }
      // 情况2：当前在非最后一页（封面/section1/section2）
      else {
        // 防连续滚动：1秒内不重复触发
        if (now - this.lastScrollTime < this.TIME_LIMIT) {
          e.preventDefault()
          return
        }

        this.lastScrollTime = now
        // 判断滚动方向，更新当前页面索引
        if (e.deltaY > 0) {
          // 向下滚动：前往下一页（不超过最后一页）
          if (this.currentPage < this.lastPageIndex) {
            this.currentPage++
          }
        } else {
          // 向上滚动：前往上一页（不小于0）
          if (this.currentPage > 0) {
            this.currentPage--
          }
        }
        // 滚动到目标页面
        this.pages[this.currentPage].scrollIntoView({ behavior: 'smooth' })
        e.preventDefault()
      }
    },

    // ========== 11. 分页逻辑：滚动时更新当前页面索引（新增） ==========
    handleScrollUpdateCurrentPage() {
      // 判断点：视口顶部往下1/3处（避免页面边缘触发误判）
      const currentScrollPos = window.scrollY + window.innerHeight / 3

      this.pages.forEach((page, index) => {
        const pageTop = this.getElementPosition(page)
        const pageBottom = pageTop + page.offsetHeight

        // 最后一页：只要滚动到顶部附近（-100px）就视为当前页
        if (index === this.lastPageIndex) {
          if (currentScrollPos >= pageTop - 100) {
            this.currentPage = index
          }
        }
        // 其他页：判断点在页面范围内 → 视为当前页
        else {
          if (currentScrollPos >= pageTop && currentScrollPos < pageBottom) {
            this.currentPage = index
          }
        }
      })
    }
  },
  watch: {
    $route() {
      this.optionActive = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .messageBox{
    // width: 100%;
    // height: 100vh;
    position: fixed;
    bottom: 30%;
    right: 10px;
    z-index: 11;
    
/* 动画图标样式 */
.animated-logo {
  width: 91px;
  height: 82px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 5px 0;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  
  /* 初始状态：正常显示 */
  right: -50px;
  top: -320px;
  opacity: 0.8;

  .tipsBox{
    width: 91px;
    position: absolute;
    left: -80px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0;
      transition: opacity 0.5s ease-in-out;
      
      &.visible {
        opacity: 1;
      }
    }
  }
  
  .iconBox {
    width: 91px;
    display: flex;
    justify-content: center;
    transform: rotate(315deg);
  }
  
  .icon1 {
    width: 100%;
    height: auto;
    opacity: 1;
  }
}

/* 鼠标悬停状态 */
.animated-logo.logo-hover {
  opacity: 1;
  
  .icon1 {
    transform: scale(1.1);
    transition: all 0.1s ease;
  }
}

/* 点击后的动画状态 */
.animated-logo.logo-final {
  /* 动画过程：先隐藏 */
  opacity: 0;
  transform: scale(0.1);
  right: -40px;
  top: -20px;
  
  /* 最终状态：在动画最后显示完整 */
  animation: logoAnimation 0.5s ease-in-out forwards;
  
  .iconBox {
    transform: rotate(270deg);
    opacity: 0;
    animation: iconBoxAnimation 0.5s ease-in-out forwards;
  }
  
  .icon {
    transform: scale(0.1);
    opacity: 0;
    animation: iconAnimation 0.5s ease-in-out forwards;
  }
}

/* 关键帧动画 */
@keyframes logoAnimation {
  0% {
    opacity: 0.8;
    transform: scale(1);
    right: -40px;
    top: -20px;
  }
  70% {
    opacity: 0;
    transform: scale(0.1);
    right: -20px;
    top: -12px;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    right: 0;
    top: -4px;
  }
}

@keyframes iconBoxAnimation {
  0% {
    opacity: 0;
    transform: rotate(270deg);
  }
  50% {
    opacity: 0.6;
    transform: rotate(180deg);
  }
  70% {
    opacity: 0.8;
    transform: rotate(90deg);
  }
  100% {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@keyframes iconAnimation {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  70% {
    opacity: 0;
    transform: scale(0.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
    .messageItem{
      position: relative;
      z-index: 2;
      width: 80px;
      height: 72px;
      background: #ffebeb;
      border-radius: 6px;
      margin: 0 auto 10px;
      font-size: 11px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      padding: 5px 0;
      box-sizing: border-box;
      .iconBox{
        width: 100%;
        display:flex;
        justify-content: center;
      }
      .icon{
        width: 28px;
        height: 34px;
        margin: 0 auto;
      }
      .title{
        width: 100%;
        font-size: 11px;
        text-align: justify;
        text-align-last: justify; /* 让最后一行也两端对齐 */
        line-height: 1.4; /* 增加行高 */
        word-break: break-all; /* 允许单词内换行 */
        padding: 0 4px; /* 添加内边距 */
        color: #A82028;
      }
    }
    .show{
      background:#A82028 !important;
    }
    .title1{
      color: #fff !important;
    }
  }
  .messageModle{
    width: 100%;
    height: 100vh;
    background-color: #48484891;
    position: fixed;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    .content{
      width: 50%;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 14px;
      padding: 70px 60px 65px 50px;
      box-sizing: border-box;
      font-family: Adobe Heiti Std, Adobe Heiti Std-R;
      font-weight: bold;
      text-align: left;
      .title{
        font-size: 25px;
        color: #2c2c2c;
        letter-spacing: 1.5px;
        margin-bottom: 37px;
      }
      .desc{
        font-size: 19px;
        color: #2c2c2c;
        letter-spacing: 1.12px;
        margin-bottom: 17px;
      }
      .email{
        font-size: 21px;
        color: #a81f27;
        letter-spacing: 1.25px;
        margin-bottom: 25px;
      }
      .ads{
        font-size: 19px;
        color: #4b4b4b;
        letter-spacing: 1.12px;
      }
      .logo{
        width: 100%;
        height: auto;
      }
      .codeBox{
        display: flex;
        align-items: center;
        .code{
          width: 120px;
          height: auto;
        }
      }
    }
  }
</style>